export const TEMPLATE_MESSAGE_MODE = 'wati_template_message_settings';

export function validateTemplatePrice(value) {
  if (value === null || value === undefined || value === '') throw new Error('Price per message is required.');
  const price = Number(value);
  if (!Number.isFinite(price) || price < 0) throw new Error('Price per message must be a non-negative number.');
  if (price > 100000) throw new Error('Price per message cannot exceed 100000.');
  return price;
}

export function historyRangeParams(range) {
  if (!Array.isArray(range) || range.length !== 2 || !range[0] || !range[1]) throw new Error('Select a date range before loading history.');
  const dateFrom = range[0];
  const dateTo = range[1];
  if (!dateFrom.isValid() || !dateTo.isValid() || !dateFrom.isBefore(dateTo)) throw new Error('Select a valid date range.');
  return { date_from: dateFrom.toISOString(), date_to: dateTo.toISOString() };
}

const contains = (value, query) => String(value ?? '').toLowerCase().includes(String(query || '').trim().toLowerCase());
export function filterTemplateHistory(rows, filters) {
  return (rows || []).filter(row =>
    contains(`${templateHistoryActorLabel(row)} ${row.actor_user_id || ''}`, filters.actor) &&
    contains(row.template_name, filters.template) &&
    contains(row.recipient_phone, filters.recipient) &&
    contains(row.source, filters.source) &&
    contains(row.status, filters.status) &&
    contains(row.channel_id, filters.channel)
  );
}

export const friendlyOperationalLabel = value => value
  ? String(value).replace(/_/g, ' ').replace(/\b\w/g, letter => letter.toUpperCase())
  : 'Unknown';
export const templateHistoryActorLabel = row => row.actor_name || (row.actor_user_id ? `User #${row.actor_user_id}` : 'Unknown agent');
export const templateHistoryUnitPriceLabel = row => `${row.unit_price_snapshot ?? '—'} ${row.currency || ''}`.trim();
